import { register } from '|>/shared/vjs'
import { AdCounter } from '../ad-counter'
import { BaseComponent } from '../base'
import { SkipAd } from '../skip-ad'

/**
 * Ad View component
 * Container for ad-related components (counter and skip button)
 */
@register
export class AdView extends BaseComponent {
  constructor(player, options) {
    super(player, options)
  }
}

AdView.options = {
  children: [AdCounter.as('adCounter'), SkipAd.as('skipAd')],
}
